import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pickupIcon = L.divIcon({
  html: `<div style="width:14px;height:14px;background:#FF6B00;border:2px solid white;border-radius:50%;box-shadow:0 2px 6px rgba(0,0,0,0.3)"></div>`,
  iconSize: [14, 14],
  iconAnchor: [7, 7],
  className: "",
});

const deliveryIcon = L.divIcon({
  html: `<div style="width:14px;height:14px;background:#10B981;border:2px solid white;border-radius:50%;box-shadow:0 2px 6px rgba(0,0,0,0.3)"></div>`,
  iconSize: [14, 14],
  iconAnchor: [7, 7],
  className: "",
});

function FitBounds({ pickup, delivery }) {
  const map = useMap();
  useEffect(() => {
    if (pickup && delivery) {
      const bounds = L.latLngBounds([
        [pickup.lat, pickup.lng],
        [delivery.lat, delivery.lng],
      ]);
      map.fitBounds(bounds, { padding: [30, 30] });
    }
  }, [pickup, delivery, map]);
  return null;
}

export function RoutePreview({ pickup, delivery }) {
  const [routeCoords, setRouteCoords] = useState([]);

  useEffect(() => {
    if (!pickup?.lat || !delivery?.lat) return;
    fetch(`https://router.project-osrm.org/route/v1/driving/${pickup.lng},${pickup.lat};${delivery.lng},${delivery.lat}?overview=full&geometries=geojson`)
      .then((r) => r.json())
      .then((data) => {
        if (data.code === "Ok" && data.routes?.[0]) {
          setRouteCoords(data.routes[0].geometry.coordinates.map(([lng, lat]) => [lat, lng]));
        }
      })
      .catch((err) => { if (err.response?.status !== 401) console.error(err.message); });
  }, [pickup, delivery]);

  const center = [(pickup.lat + delivery.lat) / 2, (pickup.lng + delivery.lng) / 2];

  return (
    <MapContainer center={center} zoom={6} style={{ height: "160px", width: "100%" }} zoomControl={false} attributionControl={false} dragging={false} scrollWheelZoom={false}>
      <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" />
      <FitBounds pickup={pickup} delivery={delivery} />
      <Marker position={[pickup.lat, pickup.lng]} icon={pickupIcon} />
      <Marker position={[delivery.lat, delivery.lng]} icon={deliveryIcon} />
      {routeCoords.length > 0 && (
        <Polyline positions={routeCoords} pathOptions={{ color: "#FF6B00", weight: 3, opacity: 0.8 }} />
      )}
    </MapContainer>
  );
}

export default RoutePreview;
